import { render, staticRenderFns } from "./Sm500Black.vue?vue&type=template&id=4050adc8&scoped=true&"
var script = {}
import style0 from "./Sm500Black.vue?vue&type=style&index=0&id=4050adc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4050adc8",
  null
  
)

export default component.exports